
import { Component, Inject, Input } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api/api.service';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { PaymentInitializeComponent } from 'src/app/open/payment/payment-initialize/payment-initialize.component';
import { convertToNumber } from 'src/app/shared/utils/convertToNumber';

@Component({
  selector: 'app-payment-modal',
  standalone: false,
  templateUrl: './payment-modal.component.html',
  styleUrl: './payment-modal.component.scss'
})
export class PaymentModalComponent {
  walletForm: FormGroup;
  isDarkMode!: boolean;

  isLoadingPrivileges: boolean = true;

  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;

  paymentChannels = [
    { value: 'interswitch', image: 'assets/images/interswitch-small.png' },
    { value: 'remita', image: 'assets/images/remita.png' },
    { value: 'paystack', image: 'assets/images/paystack.png' }
  ];
  


  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<PaymentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.walletForm = this.fb.group({
      paymentChannel: ['interswitch', [Validators.required]],
    });

    this.walletForm.disable()
  }



  initiatePayment(): void {
    let dialogRef = this.dialog.open(PaymentInitializeComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      disableClose: true,

      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { amount: this.dialogData.paymentAmount, paymentType: 'Debit' },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close()
    });
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,

      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openConfirmModal() {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: `Are you sure you want to pay ₦${this.dialogData.paymentAmount}?`,
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.initiatePayment();
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
